import { createContext } from 'react';
import { StringRecord } from '@/typings';
import type { FormField, FormInitialValues } from '../typings';
import { FormDomain } from '../typings';

interface FormContextProps {
  values: FormInitialValues;
  /** The values Formik was last reinitialized from — the server's, after a reset. */
  initialValues: FormInitialValues;
  dirty: boolean;
  formFieldGroups: FormField[];
  maxItems: StringRecord<{ maxItem: number; id: string }>;
  domain: FormDomain;
  /** Counts Formik's resets to a server snapshot; it moves on the render that first shows each reset's values. */
  reinitializeCount: number;
  /** Bumps each time `DynamicForm.resetFields` writes stored values back into `fieldResetIds`. */
  fieldResetCount: number;
  /** Ids the last `resetFields` call wrote; only meaningful together with `fieldResetCount`. */
  fieldResetIds: string[];
  /** Runs `task` with the form inert and busy until it settles, then returns any focus the lock dropped; absent outside a DynamicForm. */
  whileInert?: <T>(task: () => T | Promise<T>) => Promise<T>;
}

export const FormContext = createContext<FormContextProps>({
  values: {},
  initialValues: {},
  dirty: false,
  formFieldGroups: [],
  maxItems: {},
  domain: FormDomain.Unknown,
  reinitializeCount: 0,
  fieldResetCount: 0,
  fieldResetIds: [],
});
